import { Box, keyframes, Typography } from '@mui/material';

const slideProgress = keyframes`
  0% { left: -45%; }
  100% { left: 105%; }
`;

const fadeIn = keyframes`
  0% { opacity: 0; transform: translateY(6px); }
  100% { opacity: 1; transform: translateY(0); }
`;

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.6; }
`;

const LoadingLogo = ({ size = 140, fullScreen = false }) => {
  const content = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        animation: `${fadeIn} 0.4s ease both`,
      }}
    >
      {/* Logo mark + wordmark */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Box
          component="img"
          src="/simplia.png"
          alt="Simplia"
          sx={{
            height: size,
            width: size,
            objectFit: 'contain',
            animation: `${pulse} 2s ease-in-out infinite`,
          }}
          onError={(e) => { e.target.style.display = 'none'; }}
        />
      </Box>

      {/* Progress bar */}
      <Box
        sx={{
          width: size * 1.1,
          height: 3,
          bgcolor: '#E2E8F0',
          borderRadius: 2,
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            height: '100%',
            width: '45%',
            background: 'linear-gradient(90deg, transparent, #2563EB, transparent)',
            borderRadius: 2,
            animation: `${slideProgress} 1.4s ease-in-out infinite`,
          }}
        />
      </Box>
    </Box>
  );

  if (fullScreen) {
    return (
      <Box
        sx={{
          position: 'fixed',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: '#F8FAFC',
          zIndex: 9999,
        }}
      >
        {content}
      </Box>
    );
  }

  return content;
};

export default LoadingLogo;
